<template>
  <div class="full-text-question">
    <div class="question-txt">{{question.questionText}}</div>
    <div class="textarea-box">
    <b-form-textarea
      id="textarea"
      v-model="answer_"
      rows="3"
    ></b-form-textarea>
  </div>
  </div>
</template>

<script>
import syncProperty from '../../../../mixins/syncProperty'

export default {
  name: 'FeedbackQuestionFulltext',
  mixins: [
    syncProperty('answer', 'answer_')
  ],
  props: {
    question: {
      type: Object
    }
  }
}
</script>
